export const enum ButtonVariantEnum {
  Primary = 'primary',
  Default = 'default',
  External = 'external',
  Link = 'link',
  Circle = 'circle',
  Small = 'small',
  EditoLink = 'edito link',
  Email = 'email',
  LinkWithArrow = 'link with arrow',
  LinkWithDots = 'link with dots',
  ButtonWithDots = 'button with dots',
  ButtonWithDotsWhite = 'button with dots white',
  ButtonWithDotsBlack = 'button with dots black',
  PrimaryQuickBuy = 'quick buy',
  PrimaryQuickBuyWhite = 'quick buy white',
  PrimaryQuickBuyBlack = 'quick buy black',
  LabelDarkLarge = 'label dark large',
  Underlined = 'underlined'
}

export type ButtonVariant = `${ButtonVariantEnum}`;

export const enum ButtonTypeEnum {
  Transactional = 'Transactional CTA',
  TransactionalButton = 'Transactional CTA Button', // used for ctaType only
  Button = 'CTA Button',
  External = 'CTA External',
  Link = 'CTA Link',
  EditoLink = 'CTA Edito Link',
  Email = 'CTA Email',
  LinkWithDots = 'CTA Link with dots',
  ButtonWithDots = 'CTA Button with dots', // @deprecated - use 'CTA Button with dots - White' or 'CTA Button with dots - Black'
  ButtonWithDotsWhite = 'CTA Button with dots - White',
  ButtonWithDotsBlack = 'CTA Button with dots - Black',
  PrimaryQuickBuy = 'CTA Primary – Quick buy', // @deprecated - use 'CTA Primary - Quick buy - White' or 'CTA Primary - Quick buy - Black'
  PrimaryQuickBuyWhite = 'CTA Primary - Quick buy - White',
  PrimaryQuickBuyBlack = 'CTA Primary - Quick buy - Black'
}

export type ButtonType = `${ButtonTypeEnum}`;

export const enum ButtonTargetEnum {
  Self = 'open in current tab',
  Blank = 'open in new tab'
}

export type ButtonModelTarget = `${ButtonTargetEnum}`;

export const enum ButtonIconPositionEnum {
  Left = 'left',
  Right = 'right'
}

export type ButtonIconPosition = `${ButtonIconPositionEnum}`;

export type ButtonLinkTarget = '_self' | '_blank' | '_parent' | '_top' | string;
